import { faCheck, faSmileBeam } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import {
    BuscarContaLinkController,
    ListarFormularioPerguntaRespostasController,
    ResponderPesquisaSatisfacaoLinkController,
} from "../../../../Controllers/Geral/ResponderFormularioLink/ResponderFormularioLinkController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IResponderPesquisaSatisfacao } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";

interface IResponderFormularioLinkProps {}

interface URLParams {
    formulario: string;
    idOrg: string;
    guid: string;
}

export default function ResponderFormularioLink(
    props: IResponderFormularioLinkProps
) {
    const { formulario, idOrg, guid } = useParams<URLParams>();

    const {
        value: contaLink,
        loading: contaLinkloading,
        execute: buscarContaLink,
    } = useAsyncEffect(() => BuscarContaLinkController(guid, idOrg));

    const [formAtivo, setFormAtivo] = useState(contaLink?.FL_ATIVO);
    const { value: ListarFormulario, loading: ListarFormularioLoading } =
        useAsyncEffect(() =>
            ListarFormularioPerguntaRespostasController(formulario, idOrg)
        );

    const { execute: responderPesquisa, loading: responderPesquisaLoading } =
        useAsyncCallback(ResponderPesquisaSatisfacaoLinkController);

    const handleCadastrarPesquisaRespondida = (
        formData: IResponderPesquisaSatisfacao
    ) => {
        const listaRespondidos = formData.Respondidas.map((respondida) => ({
            ...respondida,
            formulario,
        }));

        if (contaLink) {
            responderPesquisa(contaLink?.ID_CASO, guid, idOrg, {
                ...formData,
                Respondidas: listaRespondidos,
                Recebimento: {
                    ...formData.Recebimento,
                    DT_ASSINATURA: new Date().toISOString(),
                },
            }).then(() => buscarContaLink());
        }
    };

    useEffect(() => {
        setFormAtivo(contaLink?.FL_ATIVO);
    }, [contaLink]);

    return (
        <OrSpinner
            loading={contaLinkloading || ListarFormularioLoading}
            spinner="capys"
        >
            {formAtivo ? (
                <div className="p-4">
                    <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                        <h3>{ListarFormulario?.DS_FORMULARIO}</h3>
                    </div>

                    <UnForm handleSubmit={handleCadastrarPesquisaRespondida}>
                        {ListarFormulario?.ListaPesquisaSatisfacaoPerguntaRespostas?.map(
                            (perguntaPai, index) => (
                                <div
                                    key={perguntaPai.ID_PERGUNTA}
                                    className={`h-100 mb-5 wrap ${
                                        perguntaPai.ID_PERGUNTA_PAI &&
                                        "ml-25 mb-0 mt-0 mr-25"
                                    } ${!perguntaPai.FL_ATIVO && "d-none"}`}
                                >
                                    <>
                                        <hr className="mb-5 mt-5" />
                                        <h4>{perguntaPai.DS_PERGUNTA}</h4>
                                    </>

                                    <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                        {perguntaPai.ID_TIPO_PERGUNTA !== 3 ? (
                                            <>
                                                {perguntaPai.PesquisaSatisfacaoRespostas?.map(
                                                    (resposta) => (
                                                        <React.Fragment
                                                            key={
                                                                resposta.ID_RESPOSTA
                                                            }
                                                        >
                                                            <li
                                                                className="m-5"
                                                                style={{
                                                                    height: 80,
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    justifyContent:
                                                                        "center",
                                                                    flexDirection:
                                                                        "column",
                                                                    textAlign:
                                                                        "center",
                                                                }}
                                                            >
                                                                <UnForm.Input
                                                                    readOnly
                                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                    value={
                                                                        perguntaPai.ID_PERGUNTA
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            "none",
                                                                    }}
                                                                    wrapperClassName="d-none"
                                                                />

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                1 ? (
                                                                    <UnForm.Input
                                                                        name={`Respondidas.${index}.idRespostas.0`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        type={
                                                                            "radio"
                                                                        }
                                                                        wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                    />
                                                                ) : null}

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                2 ? (
                                                                    <UnForm.Input
                                                                        type="checkbox"
                                                                        color="primary"
                                                                        name={`Respondidas.${index}.idRespostas`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                        wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                    />
                                                                ) : null}
                                                            </li>
                                                        </React.Fragment>
                                                    )
                                                )}
                                            </>
                                        ) : null}
                                    </ul>

                                    {!perguntaPai.ID_PERGUNTA_PAI && (
                                        <>
                                            <UnForm.Textarea
                                                label={
                                                    perguntaPai.ID_TIPO_PERGUNTA ===
                                                    3
                                                        ? "Resposta"
                                                        : "Comentário"
                                                }
                                                name={`Respondidas.${index}.DS_COMENTARIO`}
                                            />
                                        </>
                                    )}

                                    {perguntaPai.PerguntasFilhas?.map(
                                        (pergunta) => (
                                            <div className="h-100 mb-5 wrap ml-25 mb-0 mt-0 mr-25 false">
                                                <div className="mt-8">
                                                    <h4>
                                                        {
                                                            perguntaPai.DS_PERGUNTA
                                                        }
                                                    </h4>
                                                </div>
                                                <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                                    {pergunta.ID_TIPO_PERGUNTA !==
                                                    3 ? (
                                                        <>
                                                            {pergunta.PesquisaSatisfacaoRespostas.map(
                                                                (resposta) => (
                                                                    <React.Fragment
                                                                        key={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                    >
                                                                        <li
                                                                            className="m-5"
                                                                            style={{
                                                                                height: 80,
                                                                                display:
                                                                                    "flex",
                                                                                alignItems:
                                                                                    "center",
                                                                                justifyContent:
                                                                                    "center",
                                                                                flexDirection:
                                                                                    "column",
                                                                                textAlign:
                                                                                    "center",
                                                                            }}
                                                                        >
                                                                            <UnForm.Input
                                                                                readOnly
                                                                                name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                                value={
                                                                                    pergunta.ID_PERGUNTA
                                                                                }
                                                                                style={{
                                                                                    display:
                                                                                        "none",
                                                                                }}
                                                                                wrapperClassName="d-none"
                                                                            />

                                                                            {pergunta.ID_TIPO_PERGUNTA ===
                                                                            1 ? (
                                                                                <UnForm.Input
                                                                                    name={`Respondidas.${index}.idRespostas.0`}
                                                                                    label={
                                                                                        resposta.DS_RESPOSTA
                                                                                    }
                                                                                    type={
                                                                                        "radio"
                                                                                    }
                                                                                    wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                                    style={{
                                                                                        height: 35,
                                                                                        width: 35,
                                                                                    }}
                                                                                    value={
                                                                                        resposta.ID_RESPOSTA
                                                                                    }
                                                                                />
                                                                            ) : null}

                                                                            {pergunta.ID_TIPO_PERGUNTA ===
                                                                            2 ? (
                                                                                <UnForm.Input
                                                                                    type="checkbox"
                                                                                    color="primary"
                                                                                    name={`Respondidas.${index}.idRespostas`}
                                                                                    label={
                                                                                        resposta.DS_RESPOSTA
                                                                                    }
                                                                                    value={
                                                                                        resposta.ID_RESPOSTA
                                                                                    }
                                                                                    wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                                    style={{
                                                                                        height: 35,
                                                                                        width: 35,
                                                                                    }}
                                                                                />
                                                                            ) : null}
                                                                        </li>
                                                                    </React.Fragment>
                                                                )
                                                            )}
                                                        </>
                                                    ) : null}
                                                </ul>
                                            </div>
                                        )
                                    )}

                                    <hr />
                                </div>
                            )
                        )}

                        <div className="d-flex justify-content-end">
                            <UnForm.SubmitButton
                                color="success"
                                icon={faCheck}
                                loading={responderPesquisaLoading}
                                loadingSize="sm"
                                type="submit"
                                wrapperClassName="d-flex w-100 justify-content-center"
                                className="btn btn-success font-weight-bold mr-2 w-100px"
                            >
                                Enviar
                            </UnForm.SubmitButton>
                        </div>
                    </UnForm>
                </div>
            ) : (
                <AgradecimentoDeResposta />
            )}
        </OrSpinner>
    );
}

export function AgradecimentoDeResposta() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                overflowX: "hidden",
            }}
        >
            <div className="jumbotron text-center">
                <h1 className="display-3">Muito Obrigado!</h1>
                <p className="lead">
                    Agradecemos a contribuição, a pesquisa de satisfação é uma
                    parte muito importante para melhorarmos nosso atendimento!
                </p>
                <hr />
                <FontAwesomeIcon size="5x" icon={faSmileBeam} />
            </div>
        </div>
    );
}
